import { RSAA } from "redux-api-middleware"
import { State } from "../state/store"
import { getTenantSubDomain } from "../components/tenancy/TenantHooks"
import { getCredentialFromStorage } from "../components/authentication/AuthenticationStorage"
import { apiUrl } from "mco-typescript-core/src/url/host"

export const API_REQUEST = "@@mco_api_request"
export const TENANTED_API_REQUEST = "@@mco_tenanted_api_request"

export const unauthorizedApiRequestEventType = "UnauthorizedApiRequest"

export const applyTenantedApiRequestMiddleware =
	(store: any) => (next: any) => async (action: any) => {
		if (!action[TENANTED_API_REQUEST] && !action[API_REQUEST]) {
			return next(action)
		}

		const requestMarker = !!action[TENANTED_API_REQUEST]
			? TENANTED_API_REQUEST
			: API_REQUEST

		const { [requestMarker]: request, ...newAction } = action

		const headers = request.headers ? { ...request.headers } : {}
		const state = store.getState() as State
		const credential = getCredentialFromStorage()

		if (!credential) {
			throw Error("No credential/access token found")
		}

		headers["Authorization"] = `Bearer ${credential.access_token}`

		if (requestMarker === TENANTED_API_REQUEST) {
			headers["mco-tenant-subdomain"] = getTenantSubDomain(
				window.location.pathname
			)
		}

		if (state.environment.overriddenDate) {
			headers["mco-overridden-date"] = state.environment.overriddenDate
		}

		request.headers = headers
		request.endpoint = `${apiUrl}${request.endpoint}`

		newAction[RSAA] = request
		const result = await next(newAction)
		if (result.error && result.payload.status === 401) {
			document.dispatchEvent(
				new CustomEvent(unauthorizedApiRequestEventType)
			)
		}
		return result
	}

export default TENANTED_API_REQUEST
